/**
 * PublicLayout — header + footer chrome for the citizen app. Deliberately
 * lacks any auth UI (sign-in, account menu) — those land with the
 * authenticated customer-portal slice (F-059..F-068).
 */
import type { JSX } from 'react';
import { Link, Outlet } from 'react-router-dom';

export function PublicLayout(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3">
            <span
              aria-hidden="true"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-nipost-600 text-sm font-bold text-white"
            >
              NP
            </span>
            <span className="flex flex-col leading-tight">
              <span className="text-xs font-medium uppercase tracking-wider text-slate-500">
                NIPOST
              </span>
              <span className="text-base font-semibold text-slate-900">UPMP</span>
            </span>
          </Link>
          <nav aria-label="Primary" className="text-sm">
            <Link
              to="/"
              className="text-slate-600 transition-colors hover:text-nipost-700"
            >
              Track a parcel
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto w-full max-w-4xl flex-1 px-6 py-10">
        <Outlet />
      </main>
      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto flex max-w-4xl flex-col gap-1 px-6 py-6 text-xs text-slate-500 sm:flex-row sm:justify-between">
          <p>&copy; {new Date().getFullYear()} Nigerian Postal Service (NIPOST)</p>
          <p>Powered by UPMP — Unified Postal Management Platform</p>
        </div>
      </footer>
    </div>
  );
}
